import { PackageSize } from 'types/storeDeliveryFee'
import { useQueryPackageSizes } from 'hooks/masterData'
import { useMemo } from 'react'

const usePackageSizes = (): PackageSize[] => {
  const packageSizes = useQueryPackageSizes()
  return useMemo(() => {
    return packageSizes.map((packageSize) => packageSize.code as PackageSize)
  }, [packageSizes])
}

export default usePackageSizes
